module.exports = __webpack_public_path__ + "static/media/search.48727870.svg";